
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/[id]",
      function () {
        return require("private-next-pages/tools/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/[id]"])
      });
    }
  